/* global axios */

import ApiClient from './ApiClient';

class GoogleSheetImportsAPI extends ApiClient {
  constructor() {
    super('google_sheet_imports', { accountScoped: true });
  }

  sync(importId) {
    return axios.post(`${this.url}/${importId}/sync`);
  }
}

export default new GoogleSheetImportsAPI();
